var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaceholderAccessories = function SvgPlaceholderAccessories(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.503 20h6.994a3 3 0 0 1 1.976.742L58.339 25H37.66l4.866-4.258A3 3 0 0 1 44.503 20Zm-8.36 5 5.726-5.01a4 4 0 0 1 2.634-.99h6.994a4 4 0 0 1 2.634.99L59.857 25H65a4 4 0 0 1 4 4v28a4 4 0 0 1-4 4H15a4 4 0 0 1-4-4V29a4 4 0 0 1 4-4h6v-1a4 4 0 0 1 8 0v1h7.143ZM61 26H15a3 3 0 0 0-3 3v28a3 3 0 0 0 3 3h50a3 3 0 0 0 3-3V29a3 3 0 0 0-3-3h-4Zm-33-1v-1a3 3 0 1 0-6 0v1h6Zm20 25a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm0 1a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm11-8c0 6.075-4.925 11-11 11s-11-4.925-11-11 4.925-11 11-11 11 4.925 11 11Zm1 0c0 6.627-5.373 12-12 12s-12-5.373-12-12 5.373-12 12-12 12 5.373 12 12ZM21 32.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Z",
    fill: "currentColor"
  })));
};
export default SvgPlaceholderAccessories;